module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/toc.htm#als"
    }
  }, [_vm._v("Also by Mark Billingham")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("The DI Tom Thorne series")])]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("Sleepyhead")]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("Scaredy Cat")]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("Lazybones")]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("The Burning Girl")]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("Lifeless")]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("Buried")]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("Death Message")]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("Bloodline")]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("From the Dead")]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("The Demands ("), _c('em', [_vm._v("published as")]), _vm._v(" Good as Dead "), _c('em', [_vm._v("in the United Kingdom")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("The Dying Hours")]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("The Bones Beneath")]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("Time of Death")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', [_vm._v("Other fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("In the Dark")]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_vm._v("Die of Shame")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-429ba743","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/als.vue
// module id = 57
// module chunks = 0